import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const CountryByCurrencyQuery = gql`
  query ($currencyCode: String) {
    countryByCurrency(currencyCode: $currencyCode) {
      code
    }
  }
`;

interface IInputProps {
  children?: any;
  currencyCode: string | null;
}

interface IResponse {
  data: any;
}

class GetCountryByCurrencyQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const { country }: any = this.props;
    return this.props.children({
      country
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(CountryByCurrencyQuery, {
    name: 'country',
    options: props => ({
      variables: {
        currencyCode: props.currencyCode,
      }
    })
  })
)(GetCountryByCurrencyQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Countries/CountryByCurrency.ts